export enum Country {
    BE = "België",
    NL = "Nederland",
    FR = "France",
    LU = "Luxembourg",
    DE = "Deutschland",
    UK = "United Kingdom"
}
